import {applyMiddleware, createStore, compose } from 'redux';
import rootReducer from './reducers/index.js';
import thunk from 'redux-thunk';

export default createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f),
);
